// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__Pd2Mb","list":"styles_list__BA9UD"};